export default __webpack_public_path__ + "i18n/it.8b4f4dd97b883a8cd8c58b824cd25bec.json";